import { useEffect, useState, useRef } from "react";
import Apiservice from "../Apiservice";
import { useNavigate, useParams } from "react-router-dom";

const QuestionEdit = () => {
    const { questionId } = useParams();
    const navigate = useNavigate();

    const [examID, setExamID] = useState(0);
    console.log("edit body called")

    const questionRef = useRef(null);
    const option1Ref = useRef(null);
    const option2Ref = useRef(null);
    const option3Ref = useRef(null);
    const option4Ref = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const explanationRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);

    // Fetch existing question details on load
    useEffect(() => {
        const fetchQuestionDetails = async () => {
            setLoading(true);
            const token = localStorage.getItem("access_token");
            const headers = { access_token: token };

            const data = { question_id: questionId, status: 0 };
            let result = await Apiservice.QuestionById(data, headers);

            if (result.success) {
                const retrievedData = result.data[0];
                const optionsData = retrievedData.options;

                setExamID(retrievedData.exam_id);
                questionRef.current.value = retrievedData.question;
                option1Ref.current.value = optionsData[0].option1;
                option2Ref.current.value = optionsData[1].option2;
                option3Ref.current.value = optionsData[2].option3;
                option4Ref.current.value = optionsData[3].option4;
                setSelectedOption(optionsData[4].selectedOption);
                if (retrievedData.explanation && explanationRef.current) {
                    explanationRef.current.value = retrievedData.explanation;
                }
                setLoading(false)
            }else{
                setLoading(false)
            }
        };

        fetchQuestionDetails();
    }, [questionId]);

    const validateForm = () => {
        const newErrors = {};
        if (!questionRef.current.value.trim()) {
            newErrors.question = "Question is required";
        }

        if (!option1Ref.current.value.trim()) {
            newErrors.option1 = "Option1 is required";
        }

        if (!option2Ref.current.value.trim()) {
            newErrors.option2 = "Option2 is required";
        }

        if (!option3Ref.current.value.trim()) {
            newErrors.option3 = "Option3 is required";
        }
        if (!option4Ref.current.value.trim()) {
            newErrors.option4 = "Option4 is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // Handle form submission
    const handleSave = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const token = localStorage.getItem("access_token");
        const headers = { access_token: token };

        const data = {
            question_id: questionId,
            question: questionRef.current.value,
            options: [
                { option1: option1Ref.current.value, isCorrect: selectedOption === "1" },
                { option2: option2Ref.current.value, isCorrect: selectedOption === "2" },
                { option3: option3Ref.current.value, isCorrect: selectedOption === "3" },
                { option4: option4Ref.current.value, isCorrect: selectedOption === "4" },
                { selectedOption: selectedOption }
            ],
            explanation: explanationRef?.current?.value || "",
            status: 0
        };

        let result = await Apiservice.UpdateQuestion(data, headers);

        if (result.success) {
            navigate(`/allquestions/${(examID)}`, {
                state: {
                    newQuestionId: questionId
                }
            });
        } else {
            alert(result.message);
        }
    };

    return (
        <>
            <div className="container-fluid" style={{ backgroundColor: 'white', userSelect: 'none' }}>
                <div className="row mb-2">
                    {/* {
                        loading ? (
                            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                                <div className="text-center">
                                   
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                        style={{
                                            width: "2rem",
                                            height: "2rem",
                                            borderWidth: "3px",
                                        }}
                                    >
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                   
                                    <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                                </div>
                            </div>
                        )
                            :
                            (
                                <> */}
                                    <div className="col-12">
                                        <div className="row text-center mb-2">
                                            <div className="col">Edit Question</div>
                                        </div>
                                        <div className="questionadd p-2">
                                            <div className="row mb-2">
                                                <div className="col-3">
                                                    <label className="form-label">Question</label>
                                                </div>
                                                <div className="col-9">
                                                    <textarea
                                                        rows="3"
                                                        className={`form-control form-control-sm ${errors.question ? "is-invalid" : ""}`}
                                                        // value={question}
                                                        // onChange={(e) => setQuestion(e.target.value)}
                                                        ref={questionRef}
                                                    ></textarea>
                                                    {errors.question && <div className="invalid-feedback">{errors.question}</div>}
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-3">
                                                    <label className="form-label">Options</label>
                                                </div>
                                                <div className="col-12 col-md-9">
                                                    {[1, 2, 3, 4].map((option) => (
                                                        <div className="row mb-1" key={option}>
                                                            <div className="col-2 text-end">
                                                                <input
                                                                    type="radio"
                                                                    className="btn-check"
                                                                    name="options"
                                                                    id={`option${option}`}
                                                                    value={option}
                                                                    checked={selectedOption === `${option}`}
                                                                    onChange={(e) => setSelectedOption(e.target.value)}
                                                                />
                                                                <label className="btn btn-outline-danger" htmlFor={`option${option}`}>
                                                                    {String.fromCharCode(96 + option)} {/* 'a', 'b', 'c', 'd' */}
                                                                </label>
                                                            </div>
                                                            <div className="md-col col">
                                                                <input
                                                                    type="text"
                                                                    className={`form-control form-control-sm ${errors[`option${option}`] ? "is-invalid" : ""}`}
                                                                    placeholder={`Option - ${option}`}
                                                                    ref={
                                                                        option === 1
                                                                            ? option1Ref
                                                                            : option === 2
                                                                                ? option2Ref
                                                                                : option === 3
                                                                                    ? option3Ref
                                                                                    : option4Ref
                                                                    }
                                                                    defaultValue={
                                                                        option === 1
                                                                            ? option1Ref.current?.value
                                                                            : option === 2
                                                                                ? option2Ref.current?.value
                                                                                : option === 3
                                                                                    ? option3Ref.current?.value
                                                                                    : option4Ref.current?.value
                                                                    }
                                                                />
                                                                {errors[`option${option}`] && (
                                                                    <div className="invalid-feedback">{errors[`option${option}`]}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}


                                                </div>
                                            </div>
                                            {/* <div className="row mb-2">
                                <div className="col-3">Explanation</div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Explanation"
                                        ref={explanationRef}
                                    />
                                </div>
                            </div> */}
                                            <div className="row text-center">
                                                <div className="col">
                                                    <button className="btn btn-sm btn-primary" onClick={handleSave}>
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                {/* </>
                            )
                    } */}
                </div >
            </div >
        </>
    );
};

export default QuestionEdit;
